import { getParameterByName, updateURLParameter } from "helpers/utils";
import React from "react";

const { Grid, TextField, Box } = require("@material-ui/core");

export function RangeFilter({
  locationSearch,
  setLocationSearch,
  fromParam,
  fromParamLabel,
  toParam,
  toParamLabel,
}) {
  const handleChange = (prop) => (e) => {
    const value = e.target.value || "";
    const search = updateURLParameter(locationSearch, prop, value);
    setLocationSearch(search);
  };

  return (
    <Grid container spacing={2}>
      <Grid item>
        <TextField
          variant="standard"
          margin="normal"
          label={fromParamLabel}
          value={getParameterByName(fromParam, locationSearch) || ""}
          onChange={handleChange(fromParam)}
          type={"number"}
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
        />
      </Grid>
      <Grid item>
        <TextField
          variant="standard"
          margin="normal"
          label={toParamLabel}
          value={getParameterByName(toParam, locationSearch) || ""}
          onChange={handleChange(toParam)}
          type={"number"}
          style={{
            input: {
              color: "#fff !Important",
              "&::placeholder": {
                opacity: 1,
              },
            },
            label: { color: "#8c8c8c" },
          }}
        />
      </Grid>
    </Grid>
  );
}
